import { Box } from "@mui/material";
import React from "react";
import { GetCurrentObj } from "../../../Redux/Reducers/redux-slice-drive";
import { TreeContext } from "../../../Redux/Reducers/redux-slice-tree";
import { useAppSelector } from "../../../Redux/redux-store";
import Panel from "../../Panels/Panel/panel";
import AssetTreeView from "../../TreeView/TitleTreeView/asset-tree-view-2";

export interface DriveTreeProps {
  headObjectId: number | undefined;
}

const DriveTreeView: React.FC<DriveTreeProps> = (props) => {
  const headObjectId = props.headObjectId;
  const currentObject = useAppSelector(GetCurrentObj);

  return (
    <Panel noWrapper open position="left" sx={{ height: "100%", overflow: "hidden" }}>
      <Box
        px={1}
        py={1}
        sx={(theme) => ({
          height: "100%",
          overflowY: "scroll",
          ...theme.helpers(theme).scrollBar,
        })}
      >
        {headObjectId && (
          <AssetTreeView
            context={TreeContext.DriveTreeview}
            rootObjectId={headObjectId}
            currentAssetId={currentObject ? currentObject.id : undefined}
            disableSelection
            hilightedObjectId={currentObject ? currentObject.id : undefined}
            hideRoot
          />
        )}
      </Box>
    </Panel>
  );
};

export default DriveTreeView;
